export const BuiltInAddresses = {
    mainnet: {
        'nameRegistry:set_child_record': {
            address: 'KT1QHLk1EMUA8BPH3FvRUeUmbTspmAhb7kpd',
        },
        'nameRegistry:update_record': {
            address: 'KT1H1MqmUM4aK9i1833EBmYCCEfkbt6ZdSBc',
        },
        'nameRegistry:claim_reverse_record': {
            address: 'KT1TnTr6b2YxSx2xUQ8Vz3MoWy771ta66yGx',
        },
        'nameRegistry:update_reverse_record': {
            address: 'KT1J9VpjiH5cmcsskNb8gEXpBtjD4zrAx4Vo',
        },
        nameRegistry: {
            address: 'KT1F7JKNqwaoLzRsMio1MQC7zv3jG9dHcDdJ',
            resolveProxyContract: true,
        },
        'tldRegistrar:tez:commit': {
            address: 'KT1P8n2qzJjwMPbHJfi4o8xu6Pe3gaU3u2A3',
        },
        'tldRegistrar:tez': {
            address: 'KT1P8n2qzJjwMPbHJfi4o8xu6Pe3gaU3u2A3',
            resolveProxyContract: true,
        },
        'tldRegistrar:tez:buy': {
            address: 'KT191reDVKrLxU9rjTSxg53wRqj6zh8pnHgr',
        },
        'tldRegistrar:tez:renew': {
            address: 'KT1EVYBj3f1rZHNeUtq4ZvVxPTs77wuHwARU',
        },
        'tldRegistrar:tez:bid': {
            address: 'KT1CaSP4dn8wasbMsfdtGiCPgYFW7bvnPRRT',
        },
        'tldRegistrar:tez:withdraw': {
            address: 'KT1CfuAbJQbAGYcjKfvEvbtNUx45LY5hfTVR',
        },
        'tldRegistrar:tez:settle': {
            address: 'KT1MeFfi4TzSCc8CF9j3qq5mecTPdc6YVUPp',
        },
        oracleRegistrar: {
            address: 'KT1MMkh1VMT8d5BVuBP2whf7RXCWeMdUfkXu',
        },
    },
    custom: null,
    ghostnet: {
        'nameRegistry:set_child_record': {
            address: 'KT1HpddfW7rX5aT2cTdsDaQZnH46bU7jQSTU',
        },
        'nameRegistry:update_record': {
            address: 'KT1Ln4t64RdCG1bK8zkH6Xi4nNQVxz7qNgyj',
        },
        'nameRegistry:claim_reverse_record': {
            address: 'KT1H19ouy5QwDBchKXcUw1QRFs5ZYyx1ezEJ',
        },
        'nameRegistry:update_reverse_record': {
            address: 'KT1HDUc2xtPHqWQcjE1WuinTTHajXQN3asdk',
        },
        nameRegistry: {
            address: 'KT1B3j3At2XMF5P8bVoPD2WeJbZ9eaPiu3pD',
            resolveProxyContract: true,
        },
        'tldRegistrar:gho:commit': {
            address: 'KT1PEnPDgGKyHvaGzWj6VJJYwobToiW2frff',
        },
        'tldRegistrar:gho': {
            address: 'KT1PEnPDgGKyHvaGzWj6VJJYwobToiW2frff',
            resolveProxyContract: true,
        },
        'tldRegistrar:gho:buy': {
            address: 'KT1Ks7BBTLLjD9PsdCboCL7fYEfq8z1mEvU1',
        },
        'tldRegistrar:gho:renew': {
            address: 'KT1Bv32pdMYmBJeMa2HsyUQZiC6FNj1dX6VR',
        },
        'tldRegistrar:gho:bid': {
            address: 'KT1P3wdbusZK2sj16YXxRViezzWCPXpiE28P',
        },
        'tldRegistrar:gho:withdraw': {
            address: 'KT1C7EF4c1pnPW9qcfNRiTPj5tBFMQJtvUhq',
        },
        'tldRegistrar:gho:settle': {
            address: 'KT1DMNPg3b3fJQpjXULcXjucEXfwq3zGTKGo',
        },
        'tldRegistrar:a1:commit': {
            address: 'KT1PiEKNUgDyr4gA5Z5WE6Vi7e9MKjre6Vyy',
        },
        'tldRegistrar:a1': {
            address: 'KT1PiEKNUgDyr4gA5Z5WE6Vi7e9MKjre6Vyy',
            resolveProxyContract: true,
        },
        'tldRegistrar:a1:buy': {
            address: 'KT1C6uf5vhzjwcpNvKdQWMVg8JxFswXrurGD',
        },
        'tldRegistrar:a1:renew': {
            address: 'KT1GE4S9PqFx7RMzuA26oXRYf9iJXnMdMyDn',
        },
        'tldRegistrar:a1:bid': {
            address: 'KT1K9teWXfPPozW5VBUegPvUVgtXrnoJidV7',
        },
        'tldRegistrar:a1:withdraw': {
            address: 'KT1WMQnp2sFF7r2ECYW35prfjYFrxVczaEat',
        },
        'tldRegistrar:a1:settle': {
            address: 'KT1NBWg6RK6CH2hhvtQWofadqVeDa8MEEWmc',
        },
        'tldRegistrar:a2:commit': {
            address: 'KT1RnBSGukTTEN6NzcNVyZcArGx2VKdsL4uU',
        },
        'tldRegistrar:a2': {
            address: 'KT1RnBSGukTTEN6NzcNVyZcArGx2VKdsL4uU',
            resolveProxyContract: true,
        },
        'tldRegistrar:a2:buy': {
            address: 'KT1GUfkv3jMMuKhVwu8NFck4DHGynS3YLkn4',
        },
        'tldRegistrar:a2:renew': {
            address: 'KT1JNxJ46cJTk37Lc2fdGs7WgSwNGbimaxcr',
        },
        'tldRegistrar:a2:bid': {
            address: 'KT1VN7wyuRjXAD8W4GMCC78NAcXFv4GKY8aA',
        },
        'tldRegistrar:a2:withdraw': {
            address: 'KT1FFNsV26cY2AbtR7H6vbdAX3dQp3nk6iTj',
        },
        'tldRegistrar:a2:settle': {
            address: 'KT1WzbK971hoRBtPuifq6Dp2wsw3Fp2uodNL',
        },
        'tldRegistrar:a3:commit': {
            address: 'KT18eVEy9H2gCKZqZ3gc4ZN7EhvSPNQEwSmc',
        },
        'tldRegistrar:a3': {
            address: 'KT18eVEy9H2gCKZqZ3gc4ZN7EhvSPNQEwSmc',
            resolveProxyContract: true,
        },
        'tldRegistrar:a3:buy': {
            address: 'KT1TtPKzV94QQr4cAXV7GtiXPV95cgBhiweD',
        },
        'tldRegistrar:a3:renew': {
            address: 'KT1G3TCBEpjTR8YnZ4j3D6pehs7Xwodnng4U',
        },
        'tldRegistrar:a3:bid': {
            address: 'KT1EaiCWMt5vbqjpmjw9Wq8gxqLWFEzaPMWG',
        },
        'tldRegistrar:a3:withdraw': {
            address: 'KT1VkfPjHEjvhuinsKBEZCGgx7LMapVsVERs',
        },
        'tldRegistrar:a3:settle': {
            address: 'KT1LFMdquFkEUVu9Xf5aAtNR3BF25sprz7qh',
        },
        oracleRegistrar: {
            address: 'KT1GBZDGVJ85Sg4t3ppjGiRn4382fPeo3f3T',
        },
    },
    limanet: {
        'nameRegistry:set_child_record': {
            address: 'KT1T2eedhYhYCpUAtsb9DSU9PuZhDcFcVfJc',
        },
        'nameRegistry:update_record': {
            address: 'KT1FPBAxUnJexdzRWu3Wf4VLCDSiAmhp8tv2',
        },
        'nameRegistry:claim_reverse_record': {
            address: 'KT1Vpg7jHwnvBd4UL3BZr5qo7UwmyvaywFJa',
        },
        'nameRegistry:update_reverse_record': {
            address: 'KT1Aj4XvZQ4gNK6uMp7ZqVogwYDZfTmNAEMi',
        },
        nameRegistry: {
            address: 'KT18sWuxruTWPRqR6D1yKm3FERbWL6CoZ9so',
            resolveProxyContract: true,
        },
        'tldRegistrar:lim:commit': {
            address: 'KT1PrrkPr9YAe7CocM5JDijtDcqq4Y1eksvX',
        },
        'tldRegistrar:lim': {
            address: 'KT1PrrkPr9YAe7CocM5JDijtDcqq4Y1eksvX',
            resolveProxyContract: true,
        },
        'tldRegistrar:lim:buy': {
            address: 'KT1RcS6ktqTrrnzLL138Tur18ax1SLTZvx74',
        },
        'tldRegistrar:lim:renew': {
            address: 'KT1AvdiT2CT6zKPjZCxTSEyb72XFD54JDtuA',
        },
        'tldRegistrar:lim:bid': {
            address: 'KT1M5XZekSdkbADtyxw8wPZRJZej52rbH9iA',
        },
        'tldRegistrar:lim:withdraw': {
            address: 'KT1HV5KaBB6x6g9QQhnBCTepyKGVgNaqGoB8',
        },
        'tldRegistrar:lim:settle': {
            address: 'KT1MkgP1w43ewEmozTBCu7Wjg6UsqxSMMokr',
        },
        'tldRegistrar:a1:commit': {
            address: 'KT1HzGJZhSQYvTVEa94aX1HdH7nqV4MNN3cx',
        },
        'tldRegistrar:a1': {
            address: 'KT1HzGJZhSQYvTVEa94aX1HdH7nqV4MNN3cx',
            resolveProxyContract: true,
        },
        'tldRegistrar:a1:buy': {
            address: 'KT18josQg5biFqZA4QQT3U9vZrHfuk9qYTNd',
        },
        'tldRegistrar:a1:renew': {
            address: 'KT1VZoRtZvPLP1eSQajppK1rvTFpWzj73WLn',
        },
        'tldRegistrar:a1:bid': {
            address: 'KT1BjMekcbBCWjcE4orb41Nxy7UmiS5hxnbs',
        },
        'tldRegistrar:a1:withdraw': {
            address: 'KT1GMZQtawKDXcQB5hdExifainoVAwm2o1fG',
        },
        'tldRegistrar:a1:settle': {
            address: 'KT1LtnFF1LtvHfu6nb4fa82TrRAwutoEgtF4',
        },
        'tldRegistrar:a2:commit': {
            address: 'KT1TKV1Qd3PWLT8rCTgSjcdpXWYL4YmCB5YJ',
        },
        'tldRegistrar:a2': {
            address: 'KT1TKV1Qd3PWLT8rCTgSjcdpXWYL4YmCB5YJ',
            resolveProxyContract: true,
        },
        'tldRegistrar:a2:buy': {
            address: 'KT1XbTfBRZG58xkTHaPeBdFq7TgngqEhxMFi',
        },
        'tldRegistrar:a2:renew': {
            address: 'KT1G738kKjn4DavLLafDi22j6kgzddCgEYUL',
        },
        'tldRegistrar:a2:bid': {
            address: 'KT1QfsqrLeVuvgiq2CnhZYmQm6hSYFtKEacy',
        },
        'tldRegistrar:a2:withdraw': {
            address: 'KT19dgymzNxQtNzpFw7KiRzJa1pUNw1N1Zey',
        },
        'tldRegistrar:a2:settle': {
            address: 'KT1BZk5nwvHa1qzzqckzLaEcuuEkRPmeTDoD',
        },
        'tldRegistrar:a3:commit': {
            address: 'KT1BfZtCBHBnNH1YVgHhMtxHs8v8MytPd7GQ',
        },
        'tldRegistrar:a3': {
            address: 'KT1BfZtCBHBnNH1YVgHhMtxHs8v8MytPd7GQ',
            resolveProxyContract: true,
        },
        'tldRegistrar:a3:buy': {
            address: 'KT1ReGufYB6jPvH8ZF8HkS7vnJPfWtSCY1rj',
        },
        'tldRegistrar:a3:renew': {
            address: 'KT1H7BUhudmXRBeaqUzTF9DZmQbnXEZ6m3YM',
        },
        'tldRegistrar:a3:bid': {
            address: 'KT1SrjiLnss66iNbBs4e2Zg7wS76LCoES6sx',
        },
        'tldRegistrar:a3:withdraw': {
            address: 'KT1CiwYN8ENi7AmacH1BopAUL42KUZDs8DCE',
        },
        'tldRegistrar:a3:settle': {
            address: 'KT1HDbyoK26Cz1cbBwTaiztLuVriknBwgpV9',
        },
        oracleRegistrar: {
            address: 'KT1NoAPZDkz922nD3wWNMnn5NherKjNdmNa7',
        },
    },
};
